<template>
  <div class="text-center pt-2">
    <v-pagination 
      :key="`pagination-${currentPage}-${pageCount}`"
      :model-value="currentPage"
      :length="pageCount"
      :total-visible="6" 
      next-icon="fas fa-angle-right"
      prev-icon="fas fa-angle-left"
      @update:model-value="handlePageChange"
    ></v-pagination>
  </div>
</template>

<script>
export default {
  name: 'StudentPagination',
  
  props: {
    currentPage: { type: Number, required: true },
    pageCount: { type: Number, required: true }
  },
  
  emits: ['page-change'],
  
  methods: {
    handlePageChange(page) {
      this.$emit('page-change', page)
    }
  }
}
</script>